<template>
    <ul
        id="breadcrumb"
        class="breadcrumb"
    >
        <li>
            <NuxtLink :to="'/'">
                <IconPlayground :tw-class="'w-4 h-4 fill-secondary'"/>
            </NuxtLink>
        </li>
        <li>
            <NuxtLink :to="{name:'categories'}">
                Produkte
            </NuxtLink>
        </li>
        <li v-if="props.title !== ''">
            {{ props.title }}
        </li>
    </ul>
</template>

<script setup lang="ts">
import IconPlayground from '~/components/Icons/IconPlayground.vue';

const props = withDefaults(defineProps<{ title?: string }>(), {title: ''});
</script>
